// @ts-nocheck
import * as Types from "../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type SnapshotDetailsQueryVariables = Types.Exact<{
  serverId: Types.Scalars["ID"]["input"];
  collectedAt: Types.Scalars["Int"]["input"];
  kind: Types.Scalars["String"]["input"];
}>;

export type SnapshotDetailsQuery = {
  __typename?: "GraphqlQuery";
  getSnapshotDetails: {
    __typename?: "Snapshot";
    id: string;
    submitter: string;
    collectedAt: number;
    kind: string;
    hasError: boolean;
    errorMessage?: string | null;
    systemJson?: any | null;
  };
};

export const SnapshotDetailsDocument = gql`
  query SnapshotDetails($serverId: ID!, $collectedAt: Int!, $kind: String!) {
    getSnapshotDetails(
      serverId: $serverId
      collectedAt: $collectedAt
      kind: $kind
    ) {
      id
      submitter
      collectedAt
      kind
      hasError
      errorMessage
      systemJson
    }
  }
`;

/**
 * __useSnapshotDetailsQuery__
 *
 * To run a query within a React component, call `useSnapshotDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSnapshotDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSnapshotDetailsQuery({
 *   variables: {
 *      serverId: // value for 'serverId'
 *      collectedAt: // value for 'collectedAt'
 *      kind: // value for 'kind'
 *   },
 * });
 */
export function useSnapshotDetailsQuery(
  baseOptions: Apollo.QueryHookOptions<
    SnapshotDetailsQuery,
    SnapshotDetailsQueryVariables
  > &
    (
      | { variables: SnapshotDetailsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SnapshotDetailsQuery, SnapshotDetailsQueryVariables>(
    SnapshotDetailsDocument,
    options,
  );
}
export function useSnapshotDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SnapshotDetailsQuery,
    SnapshotDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SnapshotDetailsQuery,
    SnapshotDetailsQueryVariables
  >(SnapshotDetailsDocument, options);
}
// @ts-ignore
export function useSnapshotDetailsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SnapshotDetailsQuery,
    SnapshotDetailsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  SnapshotDetailsQuery,
  SnapshotDetailsQueryVariables
>;
export function useSnapshotDetailsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SnapshotDetailsQuery,
        SnapshotDetailsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  SnapshotDetailsQuery | undefined,
  SnapshotDetailsQueryVariables
>;
export function useSnapshotDetailsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SnapshotDetailsQuery,
        SnapshotDetailsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    SnapshotDetailsQuery,
    SnapshotDetailsQueryVariables
  >(SnapshotDetailsDocument, options);
}
export type SnapshotDetailsQueryHookResult = ReturnType<
  typeof useSnapshotDetailsQuery
>;
export type SnapshotDetailsLazyQueryHookResult = ReturnType<
  typeof useSnapshotDetailsLazyQuery
>;
export type SnapshotDetailsSuspenseQueryHookResult = ReturnType<
  typeof useSnapshotDetailsSuspenseQuery
>;
export type SnapshotDetailsQueryResult = Apollo.QueryResult<
  SnapshotDetailsQuery,
  SnapshotDetailsQueryVariables
>;
